import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Dashboard from './dashboard';
import Monitor from './monitor';
import Errors from './error';
import Timers from './timers';
import Pending from './pending';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0;
  position: relative;
  height: calc(100vh - 120px);
  overflow: hidden;
`;

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Wrapper>
      <Switch>
        <Route exact path={`${path}`} component={Dashboard} />
        <Route path={`${path}/monitor`} component={Monitor} />
        <Route path={`${path}/error`} component={Errors} />
        <Route path={`${path}/timers`} component={Timers} />
        <Route path={`${path}/pending`} component={Pending} />
      </Switch>
    </Wrapper>
  );
};

export default Routes;
